/** カテゴリあたりの上位キーワード表示件数（バッチの SC_KW_VOLUME_TOP_N と揃える） */
export const KW_VOLUME_REPORT_TOP_N = 20;

/** テーブル初期表示件数（「すべて表示」で TOP_N まで展開） */
export const KW_VOLUME_REPORT_INITIAL_VISIBLE = 10;

/** 週セレクトに載せる最大週数（これより古い週は選択肢に出さない） */
export const KW_VOLUME_REPORT_WEEK_OPTIONS = 52;
